import styled from '@emotion/styled'
import React, { memo } from 'react'

export interface Props {
  category: string
  active?: boolean
  label: string
  onClick?: (e: any) => void
}

export const Filter = memo(function Filter({
  active = false,
  category,
  label,
  onClick,
}: Props) {
  if (!label) {
    return null
  }
  return (
    <Container
      className={active ? 'active' : undefined}
      data-category={category}
      onClick={onClick}
    >
      {label}
    </Container>
  )
})

const Container = styled.div`
  color: ${({ theme }) => theme.colors.variants.neutralDark4};
  cursor: pointer;
  font-family: ${({ theme }) => theme.fontFamily.paragraph};
  font-size: 0.8125rem;
  font-weight: 600;
  letter-spacing: 2px;
  line-height: 1.75rem;
  margin: 0.3125rem 1.125rem;
  text-transform: uppercase;
  transition: 0.3s ease-out;
  &:hover {
    color: ${({ theme }) => theme.colors.variants.neutralDark1};
  }
  &.active {
    color: ${({ theme }) => theme.colors.variants.primaryDark1};
  }

  @media (max-width: 767px) {
    margin: 0.1875rem 0.75rem;
  }
`
